module.exports = __webpack_public_path__ + "4b9f9fe37529ddb92083423f0a46fa50.pdf";